import { useQuery } from "@tanstack/react-query"
import { useApi } from "../../../hooks/useApi"
import { IdeaType } from "../types/business"

const useSearchIdeas = ({
  id,
  idea_type,
  company,
  sector,
  user,
  enabled = true,
}: {
  id?: number
  idea_type?: IdeaType
  company?: number
  sector?: number
  user?: number
  enabled: boolean
}) => {
  const { scientApi } = useApi()

  const { data, error } = useQuery(
    ["ideas-search", { id, idea_type, company, sector, user }],
    () => scientApi.ideas.search({ id, idea_type, company, sector, user }),
    {
      retry: 1,
      staleTime: Infinity, // Static list, no need to refresh.
      enabled: enabled,
      /**
       * we should not cache the search results
       * as creating a new Idea will change the search results
       */
      cacheTime: 0,
    },
  )

  return {
    ideas: data,
    error,
  }
}

export default useSearchIdeas
